<page-heading
  [title]="'user.home.pageTitle' | translate"
  [description]="'user.home.pageDescription' | translate"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form class="row" [formGroup]="formGroup">
          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 input-trend-search"
            >
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'user.home.searchPlaceholder' | translate"
                formControlName="search"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>

            <div
              class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
            >
              <button
                type="submit"
                [matMenuTriggerFor]="departmentsMenu"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>
                  {{ labelDepartment ?? ('user.home.departments' | translate) }}
                </span>
              </button>
            </div>

            <div
              class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
            >
              <button
                type="submit"
                [matMenuTriggerFor]="roles"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>
                  {{ labelRoles ?? ('user.home.permissions' | translate) }}
                </span>
              </button>
            </div>

            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 btn-group trend-button"
            >
              <button
                type="button"
                class="btn btn-primary fw-bold"
                (click)="import()"
              >
                {{ 'user.home.import' | translate }}
              </button>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 btn-group trend-button"
            >
              <button
                type="button"
                class="btn btn-success fw-bold"
                (click)="showAddUser()"
              >
                {{ 'user.home.addButton' | translate }}
              </button>
            </div>

            <!-- departments -->
            <mat-menu #departmentsMenu="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchGetListByDepartment(null)">
                {{ 'user.home.all' | translate }}
              </button>
              @for (department of departments; track $index) {
                <button
                  mat-menu-item
                  (click)="searchGetListByDepartment(department)"
                >
                  {{ department.name }}
                </button>
              }
            </mat-menu>

            <!-- roles -->
            <mat-menu #roles="matMenu">
              <button mat-menu-item (click)="searchGetListByPermission(null)">
                {{ 'user.home.all' | translate }}
              </button>
              <button
                mat-menu-item
                (click)="searchGetListByPermission(roleAdmin)"
              >
                {{ 'user.home.roleAdmin' | translate }}
              </button>
              <button
                mat-menu-item
                (click)="searchGetListByPermission(roleSupervisor)"
              >
                {{ 'user.home.roleSupervisor' | translate }}
              </button>
              <button
                mat-menu-item
                (click)="searchGetListByPermission(roleAttendant)"
              >
                {{ 'user.home.roleAttendant' | translate }}
              </button>
            </mat-menu>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if (loadingContent) {
    <content-loading-list />
  }

  @if (!loadingContent && pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'user.home.columnName' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'user.home.columnDepartment' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'user.home.columnPermissions' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'user.home.columnWorkSchedule' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'user.home.columnBlock' | translate }}</th>
            <th>
              <span class="sr-only"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track $index) {
            <tr>
              <td>
                <span class="table-user-thumbnail">
                  <img
                    class="me-2 rounded-circle"
                    [alt]="item.name"
                    [src]="getUserImage(item)"
                    (error)="onImageError($event)"
                  />
                  <strong class="text-truncate">{{ item.name }}</strong>
                </span>
              </td>
              <td>
                <p class="m-0" [matTooltip]="getDepartmentName(item).tooltip">
                  {{ getDepartmentName(item).display }}
                </p>
              </td>
              <td>
                @if (!!item.roles && item.roles.length > 0) {
                  @for (role of item.roles; track $index) {
                    <span
                      class="badge text-capitalize font-14 ms-1"
                      [ngClass]="{
                        'bg-secondary': role === 'ADMIN',
                        'bg-primary': role === 'SUPERVISOR',
                        'bg-info': role === 'ATTENDANT',
                      }"
                    >
                      {{
                        role === "ADMIN"
                          ? ('user.home.roleAdmin' | translate)
                          : role === "SUPERVISOR"
                            ? ('user.home.roleSupervisor' | translate)
                            : role === "ATTENDANT"
                              ? ('user.home.roleAttendant' | translate)
                              : ('user.home.roleUndefined' | translate)
                      }}
                    </span>
                  }
                } @else {
                  <span> {{ 'user.home.noPermission' | translate }} </span>
                }
              </td>
              <td>
                <span>{{ getDaysWeek(item) }}</span
                ><br />
                <span>{{ getHours(item) }}</span>
              </td>
              <td>
                <mat-icon
                  class="lock-icon"
                  (click)="toggleUserBlockStatus(item)"
                  [ngClass]="
                    item.blocked ? 'mdi mdi-lock' : 'mdi mdi-lock-open'
                  "
                />
              </td>
              <td>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="menu"
                    type="button"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="edit(item)">
                      {{ 'user.home.edit' | translate }}
                    </button>
                    <button mat-menu-item tabindex="0" (click)="delete(item)">
                      {{ 'user.home.remove' | translate }}
                    </button>
                    <button
                      mat-menu-item
                      tabindex="0"
                      (click)="resetPassword(item)"
                    >
                      {{ 'user.home.changePassword' | translate }}
                    </button>
                    <button
                      mat-menu-item
                      tabindex="0"
                      (click)="toggleUserBlockStatus(item)"
                    >
                      {{ item.blocked ? ('user.home.unblock' | translate) : ('user.home.block' | translate) }}
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    </div>
  } @else {
    <empty-records-component
      [message]="'user.home.emptyMessage' | translate"
      [icon]="'mdi mdi-account-alert'"
      [buttonClass]="'btn btn-info fw-bold'"
      [labelButton]="'user.home.addButton' | translate"
      (emitEvent)="showAddUser()"
    />
  }
</div>
